import { render, staticRenderFns } from "./MinistryLeadEditor.vue?vue&type=template&id=337b4a26&scoped=true&"
import script from "./MinistryLeadEditor.vue?vue&type=script&lang=js&"
export * from "./MinistryLeadEditor.vue?vue&type=script&lang=js&"
import style0 from "./MinistryLeadEditor.vue?vue&type=style&index=0&id=337b4a26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b4a26",
  null
  
)

export default component.exports